

export const useTrackerSocket = () => {
    const rootPath = 'tracker';
    const EMIT_TRACKER_EVENT = (
        data: {
            eventType: string;
        },
        callback: any,
    ) => {
        socket.emit(`${rootPath}.event`, data, callback);
    };

    return {
        EMIT_TRACKER_EVENT,
    };
};
